module.exports = __webpack_public_path__ + "img/new_53.6a5dd89d.jpg";